//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '@/config/index'
import ico3 from '@/assets/youlebang/ico-03.png'
import ico4 from '@/assets/youlebang/ico-04.png'
import ico5 from '@/assets/youlebang/ico-05.png'
import ico6 from '@/assets/youlebang/ico-06.png'
import ico7 from '@/assets/youlebang/ico-07.png'
import ico8 from '@/assets/youlebang/ico-08.png'
import ico9 from '@/assets/youlebang/ico-09.png'
import ico10 from '@/assets/youlebang/ico-10.png'
import { getNewslist } from '@/api/youzheng'
export default {
  name: 'yougongbang',
  data () {
    return {
      accounttype: this.$store.state.user.personObj.accounttype,
      isqyb: this.$store.state.user.personObj.isqyb,
      bianminList: [],
      baseUrl: config.baseUrl
    }
  },
  created () {
    this.getBianmin()
  },
  mounted () { },
  methods: {
    goto (href) {
      window.location.href = href
    },
    getBianmin () {
      getNewslist({
        pageCurrent: 1,
        pageSize: 1000,
        CATEGORYCODE: 'cat01_02',
        owner_type: config.owner_type,
        searchValue: ''
      }).then(data => {
        data.obj.forEach((item, i) => {
          this.bianminList.push({
            imgurl: config.baseUrl + item.mobileTitleImgURL,
            title: item.TITLE,
            href: item.MOBILE_LINK
          })
        })
      })
    }
  }
}
